<template>
  <div
    v-if="state.modal.isOpen"
    class="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center"
  >
    <div
      class="bg-white rounded-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto m-4 transform transition-all"
      @click.stop
    >
      <div v-if="tool" class="relative">
        <img
          :src="tool.cover"
          :alt="tool.name"
          class="w-full h-64 md:h-80 object-cover rounded-t-xl"
        />

        <button
          @click="closeModal"
          class="absolute top-4 right-4 w-10 h-10 rounded-full bg-black/50 backdrop-blur-sm flex items-center justify-center text-white hover:bg-black/70 apple-transition"
        >
          <i class="fa fa-times"></i>
        </button>

        <div class="absolute top-4 left-4">
          <span class="px-3 py-1 bg-primary text-white text-xs rounded-full">{{
            getCategoryName(tool.categoryid)
          }}</span>
        </div>

        <!-- 点赞按钮 -->
        <button
          @click="zanAction"
          class="absolute top-4 right-28 w-10 h-10 rounded-full bg-black/50 backdrop-blur-sm flex items-center justify-center text-white hover:bg-black/70 apple-transition"
          title="点赞"
        >
          <i
            class="fa"
            :class="
              tool.isZan
                ? 'fa-thumbs-up text-blue-500'
                : 'fa-thumbs-o-up hover:text-blue-500'
            "
          ></i>
        </button>

        <!-- 收藏按钮 -->
        <button
          @click="favAction"
          class="absolute top-4 right-16 w-10 h-10 rounded-full bg-black/50 backdrop-blur-sm flex items-center justify-center text-white hover:bg-black/70 apple-transition"
          title="收藏"
        >
          <i
            class="fa"
            :class="
              tool.isFav
                ? 'fa-heart text-red-500'
                : 'fa-heart-o hover:text-red-500'
            "
          ></i>
        </button>
      </div>

      <div v-if="tool" class="p-6">
        <div
          class="flex flex-col md:flex-row justify-between items-start md:items-center mb-6"
        >
          <div class="flex items-center mb-4 md:mb-0">
            <img
              :src="tool.avatar"
              alt="开发者头像"
              class="w-10 h-10 rounded-full mr-3"
            />
            <div>
              <p class="font-medium">{{ tool.authorName || tool.uname }}</p>
              <p class="text-xs text-neutral-500">
                发布于
                {{ new Date(tool.createTime).format("yyyy-MM-dd hh:mm") }}
              </p>
            </div>
          </div>
          <div class="flex items-center space-x-4">
            <div class="flex items-center">
              <i class="fa fa-star text-yellow-400 mr-1"></i>
              <span class="font-medium">{{ tool.rate }}</span>
              <span
                class="text-xs text-neutral-500 ml-1"
                v-if="tool.commentCount > 0"
                >({{ tool.commentCount }} 评价)</span
              >
            </div>
            <div class="flex items-center">
              <i class="fa fa-download text-neutral-500 mr-1"></i>
              <span class="text-xs text-neutral-500">{{
                tool.downloadCount
              }}</span>
            </div>
          </div>
        </div>

        <div class="mb-8">
          <h3 class="text-xl font-bold mb-3">{{ tool.title }}</h3>
          <p class="text-neutral-600 leading-relaxed">
            {{ tool.description }}
          </p>
          <div
            v-if="knowledgePath.length > 0"
            class="flex flex-wrap items-center gap-2 mt-3"
          >
            <span class="text-xs text-neutral-400">知识体系：</span>
            <span
              v-for="(name, i) in knowledgePath"
              :key="i"
              class="px-2.5 py-1 rounded-full text-xs bg-primary/10 text-primary"
            >
              {{ name }}
            </span>
          </div>
        </div>

        <!-- 评分和评论区 -->
        <div class="mb-8 border-t border-b border-neutral-200 py-6">
          <h3 class="text-xl font-bold mb-6">用户评价</h3>

          <!-- 评分输入区 -->
          <div
            class="mb-8 p-4 bg-neutral-100 rounded-lg"
            v-if="tool.hasDownLoad && tool.status == 1"
          >
            <h4 class="font-medium mb-3">分享你的使用体验</h4>
            <div class="flex items-center mb-4">
              <div class="flex rating-stars space-x-1">
                <i
                  v-for="n in 5"
                  :key="n"
                  class="fa text-xl cursor-pointer apple-transition"
                  :class="
                    n <= userRating
                      ? 'fa-star text-yellow-400'
                      : 'fa-star-o text-neutral-300 hover:text-yellow-400'
                  "
                  @click="userRating = n"
                ></i>
              </div>
              <span class="ml-3 text-neutral-500 text-sm">点击星星评分</span>
            </div>
            <textarea
              v-model="commentText"
              class="w-full px-4 py-2 rounded-md border border-neutral-300 focus:ring-2 focus:ring-primary focus:border-primary apple-transition"
              rows="3"
              placeholder="分享你对这个工具的使用感受和建议..."
            ></textarea>
            <div class="mt-4 flex justify-end">
              <button
                @click="submitComment"
                class="px-6 py-2 rounded-md bg-primary text-white font-medium hover:bg-primary/90 apple-transition"
              >
                提交评论
                <!-- (+1创值) -->
              </button>
            </div>
          </div>

          <!-- 评论列表 (静态模拟) -->
          <div class="space-y-6">
            <div
              class="comment-item"
              v-for="item in commentList"
              :key="item.id"
            >
              <div class="flex items-start">
                <img
                  :src="item.avatar"
                  alt="用户头像"
                  class="w-8 h-8 rounded-full mr-3"
                />
                <div class="flex-1">
                  <div class="flex justify-between items-center mb-1">
                    <h4 class="font-medium">{{ item.uname }}</h4>
                    <span class="text-xs text-neutral-500">
                      {{
                        new Date(item.createTime).format("yyyy-MM-dd hh:mm")
                      }}</span
                    >
                  </div>
                  <div class="flex mb-2 space-x-1">
                    <!-- <i
                      v-for="n in 5"
                      :key="n"
                      class="fa fa-star text-yellow-400 text-xs"
                    ></i> -->
                    <i
                      v-for="n in 5"
                      :key="n"
                      class="fa text-xl cursor-pointer apple-transition"
                      :class="
                        n <= item.rate
                          ? 'fa-star text-yellow-400'
                          : 'fa-star-o text-neutral-300 hover:text-yellow-400'
                      "
                    ></i>
                  </div>
                  <p class="text-neutral-600 text-sm">
                    {{ item.content }}
                  </p>
                  <!-- <div class="mt-2 flex items-center">
                    <button
                      class="text-xs text-neutral-500 hover:text-primary apple-transition flex items-center"
                    >
                      <i class="fa fa-thumbs-o-up mr-1"></i> 有用 (24)
                    </button>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex space-x-3" v-if="tool.status == 1">
          <button
            @click="downloadAction()"
            :disabled="!downloadEnabled"
            class="flex-1 px-6 py-3 rounded-md text-white font-medium apple-transition"
            :class="downloadEnabled ? 'bg-primary hover:bg-primary/90 cursor-pointer' : 'bg-neutral-400 cursor-not-allowed opacity-80'"
          >
            <i :class="'fa mr-1 ' + (downloadEnabled ? 'fa-download' : 'fa-ban')"></i>
            {{ downloadEnabled ? "下载工具" : "下载已关闭" }}
            <span v-if="downloadEnabled && !tool.hasDownLoad && toolIsFree">(免费)</span>
            <span v-else-if="downloadEnabled && !tool.hasDownLoad">(-{{ downloadCost }}创值)</span>
          </button>
          <button
            v-if="tool.fileType && (tool.fileType == 'html' || tool.fileType == 'zip')"
            @click="preAction()"
            :disabled="!playEnabled"
            class="flex-1 px-6 py-3 rounded-md text-white font-medium apple-transition"
            :class="playEnabled ? 'bg-green-700 hover:bg-green-700/90 cursor-pointer' : 'bg-neutral-400 cursor-not-allowed opacity-80'"
          >
            <i :class="'fa mr-1 ' + (playEnabled ? 'fa-play-circle' : 'fa-ban')"></i>
            {{ playEnabled ? "在线互动" : "在线互动已关闭" }}
            <span v-if="playEnabled && !tool.hasDownLoad && toolIsFree">(免费)</span>
            <span v-else-if="playEnabled && !tool.hasDownLoad">(-{{ downloadCost }}创值)</span>
          </button>
          <button
            v-if="tool.fileType && tool.fileType == 'html'"
            @click="insertPptAction()"
            class="px-6 py-3 rounded-md bg-white border border-secondary text-secondary font-medium hover:bg-secondary/5 apple-transition"
          >
            <i class="fa fa-file-powerpoint-o mr-1"></i> 插入PPT
          </button>
          <button
            @click="shareAction"
            class="px-6 py-3 rounded-md bg-white border border-neutral-300 text-neutral-700 font-medium hover:border-primary hover:text-primary apple-transition"
          >
            <i class="fa fa-share-alt mr-1"></i> 分享
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { globalState } from "../state";
import { ElMessageBox, ElMessage } from "element-plus";
import { requireLogin } from "../utils/authGuard";
import {
  getDownloadCost,
  isDownloadEnabled,
  isPlayEnabled,
} from "../utils/pointConfig";
import { isToolFree } from "../utils/downloadRule";

export default {
  name: "ToolDetailModal",
  data() {
    return {
      state: globalState,
      userRating: 5,
      commentText: "",
      tool: null,
      page: 1,
      total: 0,
      commentList: [],
      subMap: {},
      eduMap: {},
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isLogin() {
      return this.user && this.user.uid;
    },
    downloadCost() {
      return getDownloadCost();
    },
    // 平台是否开放下载（后台开关）
    downloadEnabled() {
      return isDownloadEnabled();
    },
    // 平台是否开放在线互动（后台开关，与下载独立）
    playEnabled() {
      return isPlayEnabled();
    },
    // 当前工具是否免创值（义乌教师 或 自己的作品）
    toolIsFree() {
      return isToolFree(
        this.tool,
        this.$store && this.$store.state.user
          ? this.$store.state.user.uid
          : ""
      );
    },
    toolId() {
      return this.state.modal.toolId;
    },

    categories() {
      return this.state.modal.categories;
    },
    // 知识路径：学科-年段-年级-学期-单元
    knowledgePath() {
      if (!this.tool) return [];
      const path = [];
      if (this.tool.subid && this.subMap[this.tool.subid]) {
        path.push(this.subMap[this.tool.subid]);
      }
      ["stageId", "gradeId", "termId", "unitId"].forEach((key) => {
        const id = this.tool[key];
        if (id && this.eduMap[id]) path.push(this.eduMap[id]);
      });
      return path;
    },
  },
  watch: {
    // 监听登录状态变化，登录状态改变时重新查询创值
    toolId(newVal) {
      if (newVal) {
        this.getTool();
      }
    },
    // 路由变化时自动关闭详情弹窗（如跳转登录/注册页），避免遮挡新页面
    $route() {
      if (this.state.modal.isOpen) {
        this.state.closeModal();
      }
    },
  },
  mounted() {
    // 组件挂载时，如果已登录则查询创值
    if (this.toolId) {
      this.getTool();
    }
    this.loadKnowledgeMaps();
  },

  methods: {
    checkLogin(router) {
      if (!this.isLogin) {
        ElMessageBox.confirm("需要使用当前功能，请先登录账号", "登录", {
          confirmButtonText: "登录",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push("/login");
          })
          .catch(() => {});
        return;
      }

      this.$axios({
        url: "user/checklogin",
      }).then((res) => {
        if (res.code == 200) {
          this.$router.push(router);
        }
      });
    },
    preAction() {
      if (!requireLogin(this, "在线使用工具")) return;
      if (!isPlayEnabled()) {
        ElMessage({
          message: "平台已关闭在线互动，暂无法在线使用",
          type: "warning",
        });
        return;
      }
      this.state.closeModal();
      this.$router.push("/play/" + this.tool.id);
    },
    insertPptAction() {
      if (!requireLogin(this, "一键插入PPT")) return;
      this.state.closeModal();
      // 跳转互动页并自动生成PPT
      this.$router.push({ path: "/play/" + this.tool.id, query: { ppt: "1" } });
    },
    downloadAction() {
      if (!requireLogin(this, "下载文件")) return;
      if (!isDownloadEnabled()) {
        ElMessage({
          message: "平台已关闭下载权限，暂无法下载",
          type: "warning",
        });
        return;
      }

      if (this.tool.hasDownLoad) {
        this.$axios({
          url: "aitool/download/" + this.tool.id, // 注意：这里建议检查URL拼接是否正确，通常需要 / 分隔，比如 "aitool/download/" + tool.id
        })
          .then(async (res) => {
            if (res.code == 200) {
              const fileUrl = res.data.file;
              // 调用下载函数
              this.downloadFile(fileUrl, this.tool.title);

              // 提示下载成功
              ElMessage({
                message: "下载已开始",
                type: "success",
              });
            } else {
              ElMessage({
                message: res.msg || "下载失败", // 注意：你原代码是 res.msh，应该是笔误，修正为 res.msg
                type: "error",
              });
            }
          })
          .catch((err) => {
            // 捕获请求异常
            ElMessage({
              message: "网络错误，下载失败",
              type: "error",
            });
            console.error("下载请求失败：", err);
          });
        return;
      }
      ElMessageBox.confirm(
        this.toolIsFree
          ? `确认免费下载工具《${this.tool.title}》`
          : `确认消耗：${this.downloadCost}创值下载工具《${this.tool.title}》`,
        "下载工具",
        {
          confirmButtonText: "下载",
          cancelButtonText: "取消",
          type: "warning",
        },
      )
        .then(() => {
          // 发起下载请求
          this.$axios({
            url: "aitool/download/" + this.tool.id, // 注意：这里建议检查URL拼接是否正确，通常需要 / 分隔，比如 "aitool/download/" + tool.id
          })
            .then(async (res) => {
              if (res.code == 200) {
                const fileUrl = res.data.file;
                // 调用下载函数
                this.downloadFile(fileUrl, this.tool.title);

                // 提示下载成功
                ElMessage({
                  message: "下载已开始",
                  type: "success",
                });
              } else {
                ElMessage({
                  message: res.msg || "下载失败", // 注意：你原代码是 res.msh，应该是笔误，修正为 res.msg
                  type: "error",
                });
              }
            })
            .catch((err) => {
              // 捕获请求异常
              ElMessage({
                message: "网络错误，下载失败",
                type: "error",
              });
              console.error("下载请求失败：", err);
            });
        })
        .catch(() => {
          // 用户取消下载的提示（可选）
          ElMessage({
            message: "已取消下载",
            type: "info",
          });
        });
    },

    // 封装文件下载函数
    downloadFile(fileUrl, fileName) {
      // 创建a标签
      fetch(fileUrl)
        .then((res) => res.blob())
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        });
    },
    getTool() {
      this.commentText = "";
      this.userRating = 5;
      var uid = "";
      if (this.isLogin) {
        uid = this.user.uid;
      }
      this.$axios({
        url: `aitool/${this.toolId}?uid=${uid}`,
      }).then(async (res) => {
        this.tool = res.data;
        await this.getComments();
      });
    },
    closeModal() {
      this.state.closeModal();
    },

    /**
     * 分享：复制当前工具的专属链接，对方打开链接会直接弹出该工具详情
     * 移动端优先唤起系统分享面板，桌面端复制到剪贴板
     */
    async shareAction() {
      const id = this.toolId || (this.tool && (this.tool.id || this.tool.toolId));
      if (!id) {
        ElMessage({ message: "工具信息未加载完成", type: "warning" });
        return;
      }
      // 工具专属页面链接：别人打开直接进该工具页面
      const url = window.location.origin + "/tool/" + id;
      const name =
        (this.tool && (this.tool.title || this.tool.name)) || "AI 教学工具";

      // 仅在移动端唤起系统分享：桌面端部分环境的 share() 会挂起，导致点了没反应
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Mobile/i.test(
        navigator.userAgent
      );
      if (isMobile && navigator.share) {
        try {
          await navigator.share({
            title: name,
            text: "分享一个好用的教学工具：" + name,
            url: url,
          });
          return;
        } catch (e) {
          // 用户取消或设备不支持，继续走复制逻辑
        }
      }

      // 复制到剪贴板
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(url);
        } else {
          const ta = document.createElement("textarea");
          ta.value = url;
          ta.style.position = "fixed";
          ta.style.opacity = "0";
          document.body.appendChild(ta);
          ta.select();
          document.execCommand("copy");
          document.body.removeChild(ta);
        }
        ElMessage({
          message: "链接已复制，发给同事即可直接打开该工具",
          type: "success",
        });
      } catch (e) {
        ElMessage({
          message: "复制失败，请手动复制：" + url,
          type: "warning",
          duration: 6000,
        });
      }
    },

    // 加载学科与知识节点 id→title 映射（用于展示知识路径）
    loadKnowledgeMaps() {
      this.$axios({ url: "subinfo/list" }).then((res) => {
        const map = {};
        (res.data || []).forEach((s) => (map[s.id] = s.title));
        this.subMap = map;
      });
      this.$axios({ url: "edu/list" }).then((res) => {
        const map = {};
        (res.data || []).forEach((n) => (map[n.id] = n.title));
        this.eduMap = map;
      });
    },

    favAction() {
      if (!requireLogin(this, "收藏工具")) return;
      if (this.tool.isFav) {
        this.tool.isFav = false;
        //取消
        this.$axios({
          url: "aitool/action/fav/" + this.tool.id,
          method: "DELETE",
        }).then((res) => {
          if (res.code != 200) {
            ElMessage.error(res.msg);
          }
        });
      } else {
        this.tool.isFav = true;
        this.$axios({
          url: "aitool/action/fav/" + this.tool.id,
        }).then((res) => {
          if (res.code != 200) {
            ElMessage.error(res.msg);
          }
        });
      }
    },

    zanAction() {
      if (!requireLogin(this, "点赞工具")) return;
      if (this.tool.isZan) {
        this.tool.isZan = false;
        //取消
        this.$axios({
          url: "aitool/action/zan/" + this.tool.id,
          method: "DELETE",
        }).then((res) => {
          if (res.code != 200) {
            ElMessage.error(res.msg);
          }
        });
      } else {
        this.tool.isZan = true;
        this.$axios({
          url: "aitool/action/zan/" + this.tool.id,
        }).then((res) => {
          if (res.code != 200) {
            ElMessage.error(res.msg);
          }
        });
      }
    },
    getCategoryName(id) {
      const category = this.categories.find((c) => c.id === id);
      return category ? category.title : "未知";
    },

    formatNumber(num) {
      if (num >= 1000) {
        return (num / 1000).toFixed(1) + "k";
      }
      return num;
    },
    async submitComment() {
      if (!requireLogin(this, "发表评论")) return;
      if (!this.commentText.trim()) {
        alert("请输入评论内容");
        return;
      }
      var data = await this.$aesEncrypt({
        toolId: this.tool.id,
        rate: this.userRating,
        content: this.commentText,
      });
      // alert("评论提交成功！");
      // this.commentText = "";
      // this.userRating = 0;
      this.$axios({
        url: "aitool/user/comment",
        method: "PUT",
        data: {
          data: data,
        },
      }).then(async (res) => {
        if (res.code == 200) {
          ElMessage.info("提交评论成功");
          this.commentText = "";
          this.userRating = 5;
          await this.getComments();
        } else {
          ElMessage.error(res.msg);
        }
      });
    },
    async getComments() {
      var data = await this.$aesEncrypt({
        page: this.page,
        pageSize: 10,
      });
      this.$axios({
        url: "aitool/user/comment/list/" + this.tool.id,
        method: "POST",
        data: {
          data: data,
        },
      }).then((res) => {
        if (res.code == 200) {
          this.total = res.data.total;
          this.commentList = res.data.list;
        } else {
          ElMessage.error(res.msg);
        }
      });
    },
  },
};
// 日期格式化扩展
Date.prototype.format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length),
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length),
      );
  return fmt;
};
</script>
